<template>
  <div class="sharingCoupons">
    <div class="sharingCouponsList">
      <div class="head_image_con">
        <img class="full_img" :src="headImages" alt="" />
        <!-- <img class="full_img" src="@/assets/images/guideShareIcon.png" alt="" /> -->
      </div>
      <p class="user_name_con">{{ nickName }}</p>
      <!-- <p>{{userAdditionalInfo}}</p> -->
      <div class="m-b-30 ticket_list_item">
        <div class="left_con bg-white p-lr-36 p-tb-34 f-cl h-block">
          <div>
            <span class="c-ft-32">{{ ticketInfo.TicketName }}</span>
          </div>
          <div>
            <div class="m-b-10 c-ft-24" :style="{ color: '#999' }">
              <span>有效期: </span>
              <span
                >{{ ticketInfo.UseStartDate }} 至
                {{ ticketInfo.UseEndDate }}</span
              >
            </div>
          </div>
          <div class="circle"></div>
          <div class="circle2"></div>
        </div>
        <div class="right_con bg-white p-lr-36 p-tb-34 c-fc-center h-block">
          <div>
            <div class="money">
              <span>￥</span>
              <span>{{ ticketInfo.Price }}</span>
            </div>
            <!-- <div class="sub-txt">{{ v.UseLimit || "" }}</div> -->
          </div>
          <!-- <div class="">
            <span>
              <van-button
                round
                color="var(--tc)"
                size="small"
                @click="handleShowUseCode(v)"
                :disabled="v.TicketStatus.Id !== 1"
                >{{
                  v.TicketStatus.Id == 1 ? "去使用" : v.TicketStatus.Name
                }}</van-button
              >
            </span>
          </div> -->
        </div>
      </div>
      <div class="sharingCouponsButton">
        <div
          class="sharingCouponsOther"
          v-if="buttonInfo && buttonInfo !== '分享给朋友'"
        >
          <!-- <p :class="[{'grey_btn_con':buttonInfo === '已领取' },'receive_btn_con']" @click="handleReceiveCoupon">
          {{buttonInfo}}
        </p> -->
          <van-button
            color="var(--tc)"
            :disabled="buttonInfo === '已领取'"
            :loading="isSubmit"
            @click="handleReceiveCoupon"
            >{{ buttonInfo }}</van-button
          >
        </div>
        <div v-if="buttonInfo === '分享给朋友'">
          <!-- <p class="receive_btn_con" @click="transferCoupon">
          分享给朋友
        </p> -->
          <van-button color="var(--tc)" @click="transferCoupon"
            >分享给朋友</van-button
          >
        </div>
      </div>
    </div>
    <div class="footer" v-if="buttonInfo === '已领取'">
      <van-button color="var(--tc)" @click="handleToCoupon" block round
        >我的票券</van-button
      >
    </div>
    <shareOverlay ref="shareOverlayRef"></shareOverlay>
  </div>
</template>

<script>
import wxConfig from "@/utils/wxConfig.js";
import shareOverlay from "@/components/shareOverlay/index.vue";
import { verifyWechatMember } from "@/utils/gFunc";
import { getReceiveCouponInfo, receiveCoupon } from "@/api/coupon";
export default {
  components: { shareOverlay },
  data() {
    return {
      // openId: this.$route.params.openId,
      ticketId: this.$route.params.id,
      sendId: this.$route.params.sendId,
      // entrance: this.$route.params.entranceType,
      vpnCode: "",
      nickName: "",
      buttonInfo: "",
      headImages: "",

      userAdditionalInfo: "",
      ticketInfo: {},
      isSubmit: false,
      shareDesc: "", // 分享描述
      shareType: false,
      isNeedRegister: false, // 是否需要注册微会员
    };
  },

  created() {
    if (!this.ticketId || !this.sendId) {
      this.$toast("缺少必要参数", "middle");
      return;
    }
    this.sharingCouponsInformation();
  },

  methods: {
    sharingCouponsInformation() {
      // var _this = this;
      getReceiveCouponInfo({
        //   // OpenId: this.openId,
        //   TicketId: this.ticketId,
        //   Entrance: this.entrance,
        id: this.sendId,
      }).then((res) => {
        if (res.ReceiveTime) {
          this.buttonInfo = "已领取";
        } else {
          this.buttonInfo = "立即领取";
        }
        this.ticketInfo = {
          TicketName: res.ProductName,
          UseStartDate: res.UseStartDate,
          UseEndDate: res.UseEndDate,
          Price: res.Price,
        };
        this.headImages = res.OldUserImageUrl;
        this.nickName = res.OldUserName;
      });
      //   .catch(err => {
      //     _this.$vux.loading.hide();
      //     this.$toast(err, 'middle');
      //   });
    },
    handleReceiveCoupon() {
      // var _this = this;
      // if (this.buttonInfo === '立即领取') {
      //   if (!this.isSubmit) {
      //     _this.$toast('数据提交中请稍候', 'middle');
      //     return;
      //   }

      if (this.isNeedRegister) {
        verifyWechatMember(() => {
          this.couponCollection();
        });
      } else {
        this.couponCollection();
      }
      // }
    },
    couponCollection() {
      // var _this = this;
      // var couponUrl = storesIssueCouponsCollect;
      this.isSubmit = true;
      var couponParams = {
        //   // OpenId: this.openId,
        //   VpnCode: this.vpnCode,
        //   TicketId: this.ticketId,
        //   Entrance: this.entrance,
        //   TicketTypeId: this.ticketTypeId
        TransferId: this.sendId,
      };
      // if (this.entrance === '0') {
      //   couponUrl = couponTransfer;
      // }
      receiveCoupon(couponParams)
        .then((res) => {
          this.$toast("领取成功");
          this.buttonInfo = "已领取";
          this.isSubmit = false;
        })
        .catch((err) => {
          this.isSubmit = false;
        });
    },
    transferCoupon() {
      this.$refs.shareOverlayRef.handleSetShowShare();
      // this.shareType = true;
      // wxConfig.WeChatShare(
      //   this,
      //   window.location.href.split("#/")[0] +
      //     "#/ReceiveGiftCoupon/" +
      //     this.ticketId +
      //     "/" +
      //     this.sendId,
      //   "送您一张优惠券",
      //   window.location.href.split("index.html")[0] +
      //     "static/image/share_coupon_icon.jpg",
      //   this.shareDesc
      // );
    },
    handleToCoupon() {
      this.$router.push({
        name: "MyCouponList",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.sharingCoupons {
  min-height: 100vh;
  padding: 0 20px;
  .sharingCouponsList {
    display: flex;
    flex-direction: column;
    align-items: center;
    .head_image_con {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      margin-top: 30px;
      overflow: hidden;
    }
    .user_name_con {
      font-size: 36px;
      color: #333;
      line-height: 70px;
      margin: 20px 0;
    }
  }
}
.ticket_list_item {
  display: flex;
  overflow: hidden;
  box-sizing: border-box;
  &:last-child {
    margin-bottom: 0 !important;
  }
}
.left_con {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 150px;
  position: relative;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  border-right: 4px dashed #f7f7f7;

  .circle {
    position: absolute;
    right: -16px;
    top: -15px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f7f7f7;
  }
  .circle2 {
    position: absolute;
    right: -16px;
    bottom: -15px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f7f7f7;
  }
}
.right_con {
  // border-top-left-radius: 10px;
  // border-bottom-left-radius: 10px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  height: 216px;
  width: 200px;

  box-sizing: border-box;
  // background: url("../../assets/images/coupon-bg.png") no-repeat;
  // background-size: cover;
  justify-content: space-between;

  .sub-txt {
    font-size: 21px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #c7beb2;
    text-align: center;
  }
  .money {
    color: #c8465c;
  }
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  height: 100px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 0 32px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}
</style>
